require ['jquery', 'custom/controller', 'custom/media-query', 'lib/inview', 'custom/forms', 'bootstrap/util', 'bootstrap/modal', 'lib/kryptonite', 'lib/cookie'], ($, controller, mq, forms) ->
  $ ->
    window.basePage = new BasePage()

  class BasePage
    constructor: ->
      @_resizeDelayed()
      @_imageLoader()
      @_skipAddressValidation()
      @_initController()
      @_initLoadingIndicator()
      @_showToTopButton()
      @_goToTop()
      @_delayedBasketRestore()
      @_settingsPanel()
      @_breadcrumbToMicrodata()
      @_seoLink()
      @_showHidePasswordAlternative()
      @_addSlashesToDate()
      @_phoneNumbers()
      @_hideNewsletterPopinAfterDisplay()
      @_disallowSemicolonInInputFields()
      @_makeEmailAddressesReadable()
      @_formNoBrowserAutoValidation()
      @_skeepersPostHandleProductUrl()

    _initController: ->
      controller.scan()

      $(document).on 'before:kryptonite', (e, action) ->
        includeSelf = action == 'replaceWith'
        controller.destroy $(e.target), includeSelf

      $(document).on 'pjax:beforeSuccess', (data, status, xhr, options, context) ->
        $selector = $(context.container.selector)
        if $selector?
          controller.destroy $selector

      $(document).ajaxSuccess (context) ->
        requestAnimationFrame ->
          controller.scan()

      $(document).ajaxSuccess =>
        @_imageLoader()

    _initLoadingIndicator: ->
      self = @

      $('form.showLoading').on 'submit', (e) ->
        self._showLoadingProgress()

      $(document).bind('ajaxSend', (event, jqxhr, settings) ->
        if self.showAjaxLoadingIndicator(settings)
          self._showLoadingProgress()
        return
      ).bind 'ajaxComplete', (event, jqxhr, settings) ->
        if !self.keepShowingAjaxLoadingIndicator(settings) && $('#loading-overlay').closest("#modalOverlayRight").length < 1
          self._hideLoadingProgress()
        return

    _showLoadingProgress: ->
      overlay = jQuery('<div data-test-loading-overlay id="loading-overlay"><div class="loading-circle"></div></div>')
      overlay.appendTo document.body
      return

    _hideLoadingProgress: ->
      $('body #loading-overlay:not(.processing)').remove()
      return

    keepShowingAjaxLoadingIndicator: (settings) ->
      if settings.xhrFields?.keepShowingLoadingIndicator?
        keepShowingLoadingIndicator = settings.xhrFields.keepShowingLoadingIndicator
        delete settings.xhrFields.keepShowingLoadingIndicator
        return keepShowingLoadingIndicator
      return

    _resizeDelayed: ->
      mq.update()
      timer = null
      $(window).on 'resize', ->
        mq.update()
        clearTimeout(timer) if timer
        timer = setTimeout(->
          $(window).trigger('resizeDelayed')
        , 200)

    _imageLoader: ->
      $('.article__picture, .article__color, .main-pictures').on 'inview', 'img[data-src]', ->
        $this = $(this)
        $this.attr 'src', $this.attr('data-src')
        $this.removeAttr 'data-src'
        if $this.data('srcset') && $this.data('sizes')
          $this.attr 'srcset', $this.data('srcset')
          $this.attr 'sizes', $this.data('sizes')
          $this.removeAttr 'data-srcset data-sizes'

    _skipAddressValidation: ->
      $('.addressValidation').on 'change', (e) ->
        form = $(e.target).closest('form')
        form.find('.skipAddressValidation').val('false')

    _showToTopButton: ->
      $(window).on 'scroll', ->
        top = $(window).scrollTop()
        if (top > 300)
          $('.to-top').addClass('visible')
        else
          $('.to-top').removeClass('visible')

    _goToTop: ->
      $('body').on 'click', '.to-top', (e) ->
        $('html, body').animate {scrollTop: 0}, 'slow'

    _delayedBasketRestore: ->
      self = @
      $ ->
        if self.meta 'bskt_rest'
          $.kryptonite
            type: "GET"
            url: '/basket-restore'

    meta: (name) ->
      return $("meta[name='#{name}'], meta[property='#{name}']").attr("content")

    showAjaxLoadingIndicator: (settings) ->
      modalLoadingIndicator = $(this).attr('data-modal-loading-indicator')

      if !modalLoadingIndicator
        if settings.xhrFields?.showLoadingIndicator?
          showLoadingIndicator = settings.xhrFields.showLoadingIndicator
          delete settings.xhrFields.showLoadingIndicator
          return showLoadingIndicator

        url = settings.url
        return url.indexOf('widget.mondialrelay') == -1 and url.indexOf('widget-colissimo') == -1 and url.indexOf('avis-verifies.com') == -1 and url.indexOf('netreviews.eu') == -1 and url.indexOf('clickEvent') == -1 and url.indexOf('searchsuggestion') == -1 and url.indexOf('servicelayer') == -1 and url.indexOf('basket-restore') == -1 and url.indexOf('firstname') == -1 and url.indexOf('autocomplete') == -1

    _settingsPanel: ->
      return unless $('#settingspanel')

      formatNumber = (number) ->
        return number if (number > 9 || number == "00")
        return '0' + number

      $('#settingspanel a.changeTime').on 'click', (e) ->
        e.preventDefault()
        day = formatNumber $('#settingspanel .day :selected').val()
        month = formatNumber $('#settingspanel .month :selected').val()
        year = $('#settingspanel .year :selected').val()
        hour = formatNumber $('#settingspanel .hour :selected').val()
        minute = formatNumber $('#settingspanel .minute :selected').val()
        second = "00"
        url = window.location.href
        if (url.indexOf('?') > 0)
          url = url.substring(0, url.indexOf('?'))
        url = url + '?previewDate=' + day + month + year + hour + minute + second
        window.location = url

      $('#settingspanel a.reset').on 'click', (e) ->
        e.preventDefault()
        url = window.location.href
        if (url.indexOf('?') > 0)
          url = url.substring(0, url.indexOf('?'))
        url = url + '?previewDate=reset'
        window.location = url

      timeout = null
      $('#settingspanel').on 'mouseover', (e) ->
        e.preventDefault()
        $(@).addClass('hover')
        window.clearTimeout(timeout)

      $('#settingspanel').on 'mouseout', (e) ->
        e.preventDefault()
        $el = $(@)
        timeout = window.setTimeout(
          ->
            $el.removeClass('hover')
        , 3000
        )

    _breadcrumbToMicrodata: ->
      urlPrefix = document.location.protocol+'//'+document.location.host
      data = '{"@context": "http://schema.org","@type": "BreadcrumbList","itemListElement":['
      $breadcrumb = $('.bread-crumb').first()
      breadcrumbItems = $breadcrumb.find('.bread-crumb__item')

      breadcrumbItems.each (index, elem) =>
        if(index!=0)
          data += ','

        data += '{"@type": "ListItem","position": '+(index+1)+',"item":{'
        $anchor = $(elem).find('a')
        if($anchor.length > 0 && $anchor.attr('href') == '#')
          data += '"@id": "'+document.location+'",'
        else if($anchor.length > 0)
          data += '"@id": "'+urlPrefix+$(elem).find('a').attr('href')+'",'
        else
          data += '"@id": "'+document.location+'",'
        data += '"name": "'+$(elem).find('span').html()+'"}}'

      data += ']}'
      @_writeMicrodataToBody(data)

    _writeMicrodataToBody: (data) ->
      script = document.createElement('script');
      script.type = "application/ld+json";
      script.innerHTML = data
      $('body').append(script)

    _seoLink: ->
      $body = $('body')
      $body.on 'click', '[data-link]', @_seoLinkAction
      $body.on 'keydown', '[data-link]', @_seoLinkAction

    _seoLinkAction: (e) ->
      if e.type == 'click' || e.key == 'Enter'
        if ($(e.currentTarget).data('modal-type') != 'modal-right')
          # without this if, clicking the right-panel-layer link will not open the layer, instead it will redirect to link
          e.preventDefault()
          $link = $(e.currentTarget)
          $body = $('body')
          $form = $('<form>').attr("method", "POST")
            .attr("action", "/prg")
            .attr("target", $link.attr("target"))

          $input = $('<input>').attr('type', 'hidden')
            .attr('name', 'link')
            .attr('value', $link.data('link'))
          $form.append($input)
          $body.append($form)
          $form.submit()

    _showHidePasswordAlternative: ->
      $('.togglePassword__switch').on 'click', (e) ->
        # refactor after merging in master $(this).closest("[data-controller-element=toggle-password-wrap]")
        container = $(this).parent()
        container.find('.togglePassword__switch').removeClass('hidden')
        $(this).addClass('hidden')
        input = $(this).parent().siblings()
        if (input.attr("type") == "password")
          input.attr("type", "text")
        else
          input.attr("type", "password")

    _isNumberOrSpecial: (e) ->
      if (e.key.length > 1)
        return true
      return e.key.match(/^[0-9]$/) and !(e.altKey or e.ctrlKey or e.metaKey or e.shiftKey)

    _addSlashesToDate: ->
      self = @
      $('.dateWithSlashes')[0]?.addEventListener 'input', (e) ->
          input = e.target.value.replace /\D/g, ''
          if input.length > 2 and input.length <= 4
            input = "#{input.slice(0, 2)}/#{input.slice(2)}"
          else if input.length > 4
            input = "#{input.slice(0, 2)}/#{input.slice(2, 4)}/#{input.slice(4, 8)}"
          e.target.value = input

    _phoneNumbers: ->
      self = @
      $('.phoneNumber').on 'keydown', (e) ->
        if !self._isNumberOrSpecial(e)
          e.stopPropagation()
          e.preventDefault()

    _hideNewsletterPopinAfterDisplay: ->
      if $('.newsletter-flyout-container').length > 0
        $.cookie('newsletter_flyout_blocked', 1, { path: '/', expires: 30 })

    _disallowSemicolonInInputFields: ->
      self = @
      $('input[type="text"]:not([readonly="true"]), input[type="email"]:not([readonly="true"])').on 'keydown', (e) ->
        if (e.key == ";")
          e.preventDefault()

      $('input[type="text"]:not([readonly="true"]), input[type="email"]:not([readonly="true"])').on 'paste', (e) ->
        $el = $(e.currentTarget)
        pastedContent = e.originalEvent.clipboardData.getData("text")
        cleanedContent = pastedContent.replace(/;/g, '').trim()
        e.preventDefault()
        $el.val($el.val() + cleanedContent)

    _makeEmailAddressesReadable: ->
        emailPattern = /\[\{([A-Za-z0-9+/=]+)\}\]/g

        decodeBase64 = (b64) ->
          try
            atob b64
          catch error
            console.error "error with decoding this", b64
            b64

        processNode = (node) ->
          original = node.nodeValue
          return unless original? and emailPattern.test(original)

          replaced = original.replace emailPattern, (match, b64) ->
            decodeBase64 b64

          node.nodeValue = replaced if replaced isnt original

        decodeTextNodes = (root = document.body) ->
          walker = document.createTreeWalker root, NodeFilter.SHOW_TEXT, null
          while node = walker.nextNode()
            processNode node

        decodeAttributes = (root = document.body) ->
          elements = root.querySelectorAll('*')
          for el in elements
            for attr in Array.from(el.attributes)
              value = attr.value
              if emailPattern.test(value)
                newValue = value.replace emailPattern, (match, b64) ->
                  decodeBase64 b64
                el.setAttribute attr.name, newValue


        initialize = ->
          decodeTextNodes()
          decodeAttributes()
          $(document).ajaxComplete -> decodeTextNodes()
          $(document).ajaxComplete -> decodeAttributes()
        initialize()


    _formNoBrowserAutoValidation: ->
      for form in $('form:not([novalidate])')
        $(form).attr('novalidate', true)

    _skeepersPostHandleProductUrl: ->
      self = @

      setTimeout ->
        self._replaceSkeepersProductUrl()
      , 1500

      $(document).on 'skeepers-widget:generated', (e) ->
        self._replaceSkeepersProductUrl()

    _replaceSkeepersProductUrl: ->
      $('[data-controller-element=skeepers-product-wrapper]').each () ->
        $reviewHeaderLink = $(this).find('a.review__header')
        if $reviewHeaderLink.length > 0
          $(this).removeClass('stars-cursor')
          $reviewHeaderLink.attr('href', $(this).data('pdp-href'))
